/* eslint-disable consistent-return */

import { useEffect } from "react";

import { useSearchParams, useRouter, usePathname } from "next/navigation";

import { AuthStore } from "@packages/store/models/AuthStore";
import { Api } from "@packages/store/services/Api";

import { PROMOCODE_KEY } from "@/constants";
import { ROUTES } from "@/routes";

import { useFetch } from "./useFetch";


export const usePromocodeAndConfirmation = (auth: AuthStore, api: Api) => {
  const searchParams = useSearchParams();
  const router = useRouter();
  const pathname = usePathname();

  // Проверка промокода, если всё хорошо то перекидываем на регистрацию
  // в случае если он истёк или пришла 404 ошибка то кидаем на страницу ошибки промокода
  const { fetch: checkPromocode } = useFetch(
    (promocode: string) => api.checkPromocode(promocode),
    (data) => {
      if (data.expiredAt === null) {
        const { isSingIn } = auth;

        localStorage.setItem(PROMOCODE_KEY, data.promocode);

        if (!isSingIn) {
          router.push(ROUTES.REGISTER);
        }
      } else {
        router.push(ROUTES.PROMOCODE_EXPIRED);
      }
    },
    (error) => {
      if (error.kind !== "not-found") return;

      router.push(ROUTES.PROMOCODE_EXPIRED);
    }
  );

  useEffect(() => {
    const promocode = searchParams.get("promocode");

    if (promocode) {
      checkPromocode(promocode);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth, pathname, router, searchParams]);
};
